import { API } from "../api";
import { IPostFeatureResponse } from "./load-feature-posts.api";

export const loadNewPostsAPI = (pageNumber: number = 1) => {
  return API.get<IPostFeatureResponse[]>(
    `/post/new-post?pageNumber=${pageNumber}`,
    {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "clean-request": "no-clean",
      },
    }
  );
};
